// extracted by mini-css-extract-plugin
export default {"message":"message_message__wT6bb","headText":"message_headText__jyUPW","phragraphStyle":"message_phragraphStyle__H2+np"};